import V from 'voUtils/V.js';
import DateEx from 'voUtils/DateEx.js';


import {
	doReq
}
from 'voUtils/RestEx.js';

import {
	findResultFields
}
from 'voUtils/BrowserEx.js';

export default {
	data: function () {
		return {
			units: [],
			selectedImageIndex: undefined,
			openstreetmap: false
		};
	},
	// props: {
	// 	filter: Object,
	// 	sorting: String,
	// 	max: String
	// },
	beforeMount: function () {

		this.checkOsmConsent();

		var results = this.$el.getElementsByClassName('unit-list-section');
		//console.log("facility==>" + parseInt(this.$el.dataset.facilityid, 10));
		let el = document.querySelector("[data-facility-id]");
		var facilityId;
		if (el) {
			facilityId = parseInt(el.getAttribute('data-facility-id'), 10);
		} else {
			console.log('element is not found..................');
		}
		//console.log('facilityId::' + facilityId);

		if (results.length) {
			this.resultFields = findResultFields(results[0].innerHTML, this.$el);
		}

		var unitgroupid = this.getUnitgroupId(facilityId);
		/*if (facilityId == 198402) { //Auf dem Branden
			unitgroupid = 49586;
		} else if (facilityId == 198403) { //In de Dickden 
			unitgroupid = 49587;
		} else if (facilityId == 198404) { //In de Stücken/Postweg
			unitgroupid = 49588;
		} else if (facilityId == 198405) { //Mittelweg 
			unitgroupid = 49589;
		}*/
		console.log("unitgroupid==>" + unitgroupid);

		var req = {
			fields: this.resultFields,
			filter: {
				//unitgroupid: 25551
				//'region.id': 8155
				unitgroupid: unitgroupid
			},
			sorting: 'random',
			//pricelist: true,
			max: 120
		};

		doReq('searchUnits', req)
			.then((res) => {
				this.units = res.units;
			});

	},

	mounted: function () {
		window.addEventListener('ccm19WidgetClosed', (event) => {
			this.checkOsmConsent();
		});
	},

	created() {
		window.addEventListener("resize", this.myEventHandler);
	},
	destroyed() {
		window.removeEventListener("resize", this.myEventHandler);
	},

	updated: function () {
		$('[data-toggle="tooltip"]').tooltip();
		$('[data-toggle="popover"]').popover();
		$(".owl-carousel.region").owlCarousel({
			loop: false,
			rewind: true,
			margin: 30,
			smartSpeed: 1000,
			autoplay: false,
			nav: true,
			responsive: {
				0: {
					items: 1
				},
				768: {
					items: 2
				},
				996: {
					items: 3

				}
			}
		});
	},
	methods: {
		checkOsmConsent: function () {
			const suffix = VOFFICE.token.substr(VOFFICE.token.length - 12);
			var cookieName = 'allowOpenstreetmap_' + suffix;
			const allowOpenstreet = this.getCookie(cookieName);
			if (allowOpenstreet) {
				this.openstreetmap = true;
			} else {
				const data = CCM.acceptedEmbeddings;
				const targetName = "OpenStreetMap";
				const entry = data.find(item => item.name === targetName);


				if (entry) {
					this.openstreetmap = true;
				} else {
					this.openstreetmap = false;
				}
			}
		},


		getCookie: function (name) {
			const nameEQ = name + "=";
			const ca = document.cookie.split(';');
			for (let i = 0; i < ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) === ' ') c = c.substring(1, c.length);
				if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
			}
			return null;
		},

		setCookie: function (name, value, days) {
			const date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			const expires = "expires=" + date.toUTCString();
			document.cookie = name + "=" + value + ";" + expires + ";path=/";
		},

		allowOpenstreetmap: function () {
			const suffix = VOFFICE.token.substr(VOFFICE.token.length - 12);
			var cookieName = 'allowOpenstreetmap_' + suffix;
			this.setCookie(cookieName, true, VOFFICE.settings.osmCookieDays);
			this.openstreetmap = true;
		},

		showOpenstreetmap: function () {
			this.openstreetmap = true;
		},
		getUnitSearchTarget: function (id) {
			return '_self';
			/*	if (window.screen.width < 768) {
					//probably phone?
					return '_self';
				} else {
					return 'unit_' + id;
				} */
		},
		getUnitgroupId: function (facilityId) {
			var unitgroupid;
			if (facilityId == 182170) { //Coordes
				unitgroupid = 41699;
			} else if (facilityId == 176033) { //Haus Bielefeld
				unitgroupid = 41698;
			} else if (facilityId == 178073) { //Schipper
				unitgroupid = 41700;
			} else if (facilityId == 208772) { //Schipper
				unitgroupid = 56382;
			} else if (facilityId == 237643) { //Kiefernhuus
				unitgroupid = 76045;
			}
			return unitgroupid;
		},
		getSearchUrl: function (facilityId) {
			var unitgroupid = this.getUnitgroupId(facilityId);
			var searchUrl = "./s#";
			if (unitgroupid) {
				searchUrl += "?unitgroupid=" + unitgroupid;
			}
			return searchUrl;
		},
		getfacilityId: function (id) {
			return parseInt(this.$el.dataset.facilityid, 10);
		},

		myEventHandler(e) {
			//	console.log(window.innerWidth);
		}
	}

};